import React from "react";

const Footer = () => {
  const FooterLogo = require("../assets/images/Lp/footer-logo.png");
  const Email = require("../assets/images/Email.png");
  const Facebook = require("../assets/images/Lp/facebook.png");
  const twitter = require("../assets/images/Lp/twitter.png");
  const github = require("../assets/images/Lp/github.png");
  const slack = require("../assets/images/Lp/slack.png");
  return (
    <div className="footer-area section">
      <div className="container flex">
        <div className="col info">
          <img className="" src={FooterLogo} width={200} alt="CustomerGenius" />
          <div class="text-sm flex text-gray-500 sm:flex-row items-center flex-col sm:pt-6 pt-3 mb-3 ">
            <div class="flex sm:mt-0 mt-3 ">
              <a
                href="/terms-conditions"
                class="text-blue underline-offset-custom"
              >
                Terms and Conditions{" "}
              </a>
              <div class="text-sm  text-gray-500 mx-1"> | </div>
              <a
                href="/privacy-policy"
                class="text-blue underline-offset-custom"
              >
                {" "}
                Privacy Policy
              </a>
            </div>
          </div>
          <div className="text-sm">
            © CustomerGenius 2025. All rights reserved.
          </div>
        </div>
        <div className="col menu">
          <div className="list-item">Home</div>
          <div className="list-item">Problems</div>
          <div className="list-item">How does it work</div>
          <div className="list-item">Integrations</div>
          <div className="list-item">Testimonials</div>
          <div className="list-item">Pricing</div>
          <div className="list-item">FAQ</div>
        </div>

        <div className="col">
          <div className="social-icon">
            {" "}
            <img className="" src={Facebook} alt="CustomerGenius" width={20} />
            <img className="" src={twitter} alt="CustomerGenius" width={20} />
            <img className="" src={github} alt="CustomerGenius" width={20} />
            <img className="" src={slack} alt="CustomerGenius" width={20} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
